import { Account } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"


function modelMapper(inputAccount: any): Account {
    return {
        id: inputAccount.id,
        name: inputAccount.name,
        date: inputAccount.date,
        siret: inputAccount.siret,
        email: inputAccount.email,
        website: inputAccount.website,
        telephone: inputAccount.telephone,
        signataire: inputAccount.signataire,
        fonctionSignataire: inputAccount.fonctionSignataire,
        address: inputAccount.address,
        famille: inputAccount.famille,
        origineCompte: inputAccount.origineCompte,
        porteurProjet: inputAccount.porteurProjet,
        observation: inputAccount.observation,
        nbLaveries: inputAccount.nbLaveries
    };
}

export function modelMapperArray(inputArray: any[]): Account[] {
    return inputArray.map(modelMapper);
}

export async function getAllAccounts(): Promise<Account[]> {
    const accounts = await getData<Account[]>("/accounts");
    return modelMapperArray(accounts ?? []);
}

export function getAccountById(id: string): Promise<Account> {
    return getData("/accounts/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export async function postAccount(account: Account): Promise<Account> {
    const response = await postData("/accounts", account);
    return modelMapper(response);
}

export function putAccount(id: string, account: Account): Promise<any> {
    return putData("accounts/" + id, account);
}

export function deleteAccount(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("accounts/" + idsStr);
}

export async function searchForAccounts(searchQuery: string): Promise<Account[]> {
    const accounts = await getData<Account[]>("accounts?" + searchQuery);
    return modelMapperArray(accounts ?? []);
}